import { loc } from "../../core/utils"
import { changePassword } from "../../service/UserService"
import ResetPasswordForm from "./components/ResetPasswordForm"
import React from "react"
import { useRef } from "react"
import { useEffect } from "react"
import { useMutation } from "react-query"

function ResetPasswordPage({ tunnelData, onSetStep, history, ...props }) {
  const { apiUrl } = tunnelData
  const { state: reactRouterHistoryState } = history?.location

  const historyLocationStateRef = useRef(null)

  const { mutate, error } = useMutation(changePassword, {
    mutationKey: "change-password",
    retry: false,
    onSuccess: (data) => {
      history.push("/login")
    },
    onError: (error) => {
      console.error("mutation error for ResetPassword", error)
    }
  })

  useEffect(() => {
    if (!!reactRouterHistoryState) {
      historyLocationStateRef.current = reactRouterHistoryState
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onSubmit(values) {
    mutate({
      apiUrl,
      changePasswordFormValues: {
        login: historyLocationStateRef?.current?.userName,
        oldPassword: values?.oldPassword,
        password: values?.newPassword,
        passwordConfirmation: values?.verifyNewPassword
      }
    })
  }

  return (
    <div className="div-center" style={{ gap: "2rem" }}>
      <h2 style={{ fontSize: "3rem" }}>{loc("password_expired")}</h2>

      {error && <div className="px-2 py-1 error-message">{loc(error.response?.data)}</div>}
      <ResetPasswordForm onSubmit={onSubmit} />
    </div>
  )
}

export default ResetPasswordPage
